import React, { useCallback } from "react";
import { Input } from "../../style/Input";
import { LoginLabel } from "../../style/Label";
import {
  LoginHeading,
} from "../../style/Login";
import { Button } from "../../style/Button";
import { useHistory } from "react-router-dom";
import { Logo1 } from "../logo/Logo";
import jsonwebtoken from "jsonwebtoken";
import { serverUrl } from "../../appconst";
import Grid from "@material-ui/core/Grid";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import IconButton from '@material-ui/core/IconButton';
import "./login.css";
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';

export class Login extends React.Component {
  constructor(props) {
    super(props);

    // Check for uus parameter early to determine if we should show login page
    let urlParams;
    if (window.location.hash && window.location.hash.includes('?')) {
      const hashQueryString = window.location.hash.split('?')[1];
      urlParams = new URLSearchParams(hashQueryString);
    } else {
      urlParams = new URLSearchParams(window.location.search);
    }
    const encryptedData = urlParams.get('uus');
    const hasAutoLogin = !!encryptedData;

    this.state = {
      username: "",
      password: "",
      openDialog: sessionStorage.getItem("signup") && sessionStorage.getItem("signup") === "success" ? true : false,
      isLoginBtnDisable: false,
      isAutoLogin: hasAutoLogin,
      isLoggingIn: hasAutoLogin
    };

    this.handleOnClick = this.handleOnClick.bind(this);
    this.forwardTOHome = this.forwardTOHome.bind(this);
    
    // Check existing session
    let data = JSON.parse(window.sessionStorage.getItem("usersession"));

    if (data && data.message !== "User Not found.") {
      var isExpired = false;
      const token = data.accessToken;
      var decodedToken = jsonwebtoken.decode(token, { complete: true });
      var dateNow = new Date();

      if (decodedToken.exp < dateNow.getTime()) isExpired = true;
      this.forwardTOHome();
    }

    // If auto-login is detected, process it immediately
    if (hasAutoLogin) {
      this.processAutoLogin(encryptedData);
    }
  }

  processAutoLogin = (encryptedData) => {
    try {
      // Decode Base64 encrypted string
      const decodedString = atob(encryptedData);
      
      // Split by $$$ to get username and password
      const parts = decodedString.split('$$$');
      
      if (parts.length === 2) {
        const username = parts[0];
        const password = parts[1];
        
        // Perform login directly without showing the form
        this.performLogin(username, password);
      } else {
        console.error('Invalid format: Expected username$$$password');
        this.setState({ isAutoLogin: false, isLoggingIn: false });
      }
    } catch (error) {
      console.error('Error decrypting credentials:', error);
      this.setState({ isAutoLogin: false, isLoggingIn: false });
    }
  }

  performLogin = (username, password) => {
    this.setState({
      isLoginBtnDisable: true,
      isLoggingIn: true
    });

    fetch(serverUrl + "/api/auth/signin", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: username,
        password: password,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          isLoginBtnDisable: false,
          isLoggingIn: false
        });
        if (
          data.message === "User Not found." ||
          data.message === "Invalid Password!"
        ) {
          // If auto-login fails, show the login page
          this.setState({ isAutoLogin: false });
          alert(data.message);
        } else {
          window.sessionStorage.setItem("usersession", JSON.stringify(data));
          this.forwardTOHome();
        }
      })
      .catch((error) => {
        console.error('Login error:', error);
        this.setState({
          isLoginBtnDisable: false,
          isLoggingIn: false,
          isAutoLogin: false
        });
      });
  }

  componentDidMount() {
    // This is now handled in constructor for auto-login
    // Keeping this for any future use
  }
  // const history = useHistory();
  //const handleOnClick = useCallback(() => history.push('/partner-home'), [history]);

  forwardTOHome = () => {
    this.props.history.push({
      pathname: "/partner-home",
    });
  };

  handleOnClick = () => {
    this.performLogin(this.state.username, this.state.password);
  };

  render() {
    // If auto-login is in progress, show loading state instead of login form
    if (this.state.isAutoLogin && this.state.isLoggingIn) {
      return (
        <Box 
          style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            flexDirection: 'column'
          }}
        >
          <Logo1 />
          <p style={{ marginTop: '20px', color: '#969696' }}>Logging you in...</p>
        </Box>
      );
    }

    // Show normal login page
    return (
      <>
        <Logo1 className="mob-visibility width100" />
        <Grid container className="min-h-100 main-box loginSection" maxWidth="100%" alignContent="center">
          <Grid
            item xs={12}
            md={6}
            justifyContent="center"
            alignContent="center"
            className="min-h-100 info-wrap"
          >
            <Logo1 className="desk-visibility" />
            <Box className="content-wrap info">
              <div className="info-text width330">
                <p style={{ marginBottom: "6px", lineHeight: "28px" }}>
                  <b className="fs27">Doceree</b><br />
                  <b className="fs27">Partner Toolbox</b>
                </p>
                <p className="info-subtext">
                  A solution hub primarily for our agency partners
                </p>
                <br />
                <p className="info-link mt-0-xs">
                  <span style={{ fontWeight: 600 }}>Partner Toolbox is a mutual collaboration
                    between Doceree and agency partners</span> who are
                  looking to showcase the possibilities of reaching
                  out to HCPs to their life sciences clients. It
                  supports the partners to demonstrate new and
                  innovative ways of engaging with HCPs in an
                  convenient manner.
                </p>
                <p className="info-link">
                  To request an access, reach out to your customer success representative or <span
                    display="block"
                    color="#969696"
                    margin="20px 0px 10px 18%"
                    onClick={() => this.props.history.push({
                      pathname: "/signup",
                    })} style={{ color: "#B263DE", fontWeight: "600", cursor: 'pointer' }} >click here</span>
                </p>
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} md={6} className="form-wrap">
            <Box className="content-wrap mt-0-xs">
              <Box className="loginForm">
                <LoginHeading>Log In</LoginHeading>
                <div className="inputBox">
                  <TextField
                    style={{
                      height: "45px",
                      width: "100%",
                      margin: "10px 0px 0px 0"
                    }}
                    label="Username:"
                    name="email"
                    value={this.state.username}
                    onChange={(event) =>
                      this.setState({ username: event.target.value })
                    }
                  />
                </div>
                <div className="inputBox">
                  <TextField
                    style={{
                      height: "45px",
                      width: "100%",
                      margin: "40px 0px 0px 0"
                    }}
                    label="Password:"
                    type="password"
                    name="password"
                    value={this.state.password}
                    onChange={(event) =>
                      this.setState({ password: event.target.value })
                    }
                  />
                </div>
                <LoginLabel
                  display="flex"
                  color="#969696"
                  padding="20px 0px 10px 0"
                  style={{ justifyContent: "end" }}
                >
                  <span className="forgot-pwd">Forgot Password?</span>
                </LoginLabel>
                <Button
                  width="100%"
                  marginTop="20px"
                  height="45px"
                  backgroundImage="linear-gradient(to right,#A45BE4 0%, #6B42F6 70%)"
                  style={{ fontWeight: 600, fontSize: "18px" }}
                  disabled={this.state.isLoginBtnDisable}
                  onClick={this.handleOnClick}
                >
                  Log In
                </Button>
                <LoginLabel
                  display="block"
                  color="#969696"
                  margin="20px 0px 10px 0"
                  className="text-center-xs text-center"
                  onClick={() => this.props.history.push({
                    pathname: "/signup",
                  })}
                >
                  Not a member? <span style={{ color: "#B263DE", fontWeight: "600", cursor: 'pointer' }} >Sign up</span>
                </LoginLabel>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Dialog
          open={this.state.openDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ maxWidth: "40vw", marginLeft: "auto", marginRight: "auto", width: "448px", textAlign: 'center' }}
        >
          <DialogContent>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="close"
              style={{ float: "right" }}
              onClick={(event) => {
                this.setState({ openDialog: false })
                sessionStorage.removeItem("signup")
              }
              }
            >
              <span style={{ float: "right", fontSize: "16px", textAlign: "left" }}>X</span>
            </IconButton>
            <DialogContentText id="alert-dialog-description" style={{ marginTop: "40px", padding: "30px" }}>
              Thank you for your interest in Doceree's Partner Toolbox.<br /><br />
              Our customer success representative will contact you shortly.
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </>
    );
  }
}